(function () {
	'use strict';

	var module = angular.module('uwAgenda.settings.agendasettings');
	module.controller('WeekschemeDaysController', 
	[
		'$scope',
		'$uibModalInstance', 
		'SchemeBroadcast',
		'HelperService', 
		'DayschemeService', 
		'DayschemeTimesService', 
		'SharedAgendaService', 
		'Alert', 
		'weekscheme', 
		'dayschemes', 
		'labels', 
		'interval', 
		WeekschemeDaysControllerFn]);

	// main controller for Weekscheme Day Overview
	function WeekschemeDaysControllerFn(
		$scope,
		$uibModalInstance,
		SchemeBroadcast, 
		HelperService, 
		DayschemeService, 
		DayschemeTimesService, 
		SharedAgendaService, 
		Alert, 
		weekscheme, 
		dayschemes, 
		labels, 
		interval) {

		var vm = this;

		// weekdays
		vm.weekdays = [];
		// possible agenda labels
		vm.labels = [];
		// currently selected label
		vm.data = {};

		vm.noSlotsSelected = false;

		activate();

		// abort
		vm.abort = function () {
			$uibModalInstance.dismiss('abort');
		};

		// save
		vm.save = function () {
			// check if there is at least one time slot selected
			var weekDays = DayschemeTimesService.data.weekdays;
			var allTimes = weekDays.reduce(function(acc, item) {
				return acc.concat(item.times);
			}, []);
			var numberOfSelectedTimes = allTimes.filter(function(time) {
				return time.vmSelected === true;
			}).length;

			if (numberOfSelectedTimes === 0) {
				vm.noSlotsSelected = true;
				return false;
			}
			
			// block modal
			HelperService.block('#modal');

			// get times array from service
			dayschemes = DayschemeTimesService.data.weekdays;
			DayschemeTimesService.clear();

			var i = 0;
			var len = dayschemes.length;

			// prepare for save
			for (i = len - 1; i >= 0; i--) {
				dayschemes[i].prepareForSave(weekscheme.id);
				// if dayscheme has been generated newly and has no times, remove it from the list, because it doesn't need to be saved
				if (dayschemes[i].id === 0 && (!dayschemes[i].times || dayschemes[i].times.length === 0)) {
					dayschemes.splice(i, 1);
				}
			} // for


			// always save 
			DayschemeService.saveWeek(dayschemes, SharedAgendaService.data.currentAgenda.id).then(function (result) {
				Alert.success(result);
				//back to overview
				$uibModalInstance.close(result);
			}, function (error) {
				HelperService.unblock("#modal");
				// close modal, because data has to be reloaded anyway
				vm.abort();
			});

		};


		// activation work
		function activate() {
			// init service 
			DayschemeTimesService.init(dayschemes, interval, SharedAgendaService.data.currentAgenda.weekStartDay);
			vm.weekdays = DayschemeTimesService.data.weekdays;

			// labels
			vm.labels = labels;
			// selected label
			vm.data = DayschemeTimesService.data;
			// select first label as default
			vm.data.label = vm.labels[0];


			// clear
			labels = null;

			var timeSelectedListener = 
				$scope.$on(SchemeBroadcast.TimeSelected, function() {
				vm.noSlotsSelected = false;
			});

			$scope.$on("$destroy", function () {
                if (timeSelectedListener) {
					timeSelectedListener();
				}
            });


		} // activate
	}
})();
